var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDurationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 2603"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.23077 4.43636C7.23077 4.19536 6.95526 4 6.61538 4C6.27551 4 6 4.19536 6 4.43636V7.6C6 7.71572 6.06483 7.82671 6.18025 7.90855L8.94947 9.87218C9.18978 10.0426 9.57944 10.0426 9.81975 9.87218C10.0601 9.70178 10.0601 9.42548 9.81975 9.25508L7.23077 7.41926V4.43636Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 0C3.13402 0 0 3.13402 0 7C0 10.866 3.13402 14 7 14C10.866 14 14 10.866 14 7C14 3.13402 10.866 0 7 0ZM0.933333 7C0.933333 3.64947 3.64947 0.933333 7 0.933333C10.3505 0.933333 13.0667 3.64947 13.0667 7C13.0667 10.3505 10.3505 13.0667 7 13.0667C3.64947 13.0667 0.933333 10.3505 0.933333 7Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDurationIcon);
export default __webpack_public_path__ + "static/media/duration-icon.9415900eb6d5f825289523224e2b24ba.svg";
export { ForwardRef as ReactComponent };